import { PROGRESS_START, PROGRESS_FINISH, PROGRESS_FAIL } from '../../../mutation-types';
import listProductAPI from '../../../../api/listProduct';

const defaultState = () => ({
    dataCategory: {
        results: '',
        pagination: ''
    },
    dataproductCategory: [],
    alert: [],
    pagination: {}
});

const state = defaultState();

const mutations = {
    listCategory(state, data) {
        state.dataCategory = Object.assign({}, state.dataCategory, data);
    },
    listProductCategory(state, data) {
        if (data.code == 'all') {
            state.dataproductCategory = data.data
        } else if (data.code == 'more') {
            state.dataproductCategory.push(...data.data)
        }
        state.pagination = data.pagination
    }
};

const actions = {
    getAllProduct({ commit, dispatch }, value) {
        let parameterObject = {}
        let parameter = '{'
        value.params.forEach((value, index) => {
            for (const [key, val] of Object.entries(value)) {
                parameter += `"filter[${index}][${key}]":"${encodeURI(val)}",`
            }
        })
        parameter = parameter.slice(0, -1)
        parameter += `,"limit": "${value.limit}"`
        parameter += `,"page": "${value.page}"`
        parameter += `}`
        parameterObject = JSON.parse(parameter)
        listProductAPI.allProductByCategoryId(parameterObject)
        .then(({ data: { data } }) => {
            if (data.results.length == 0) {
                commit('listProductCategory', { code: 'all', data: 'error', pagination: 0 });
            } else {
                if (value.page == 1)
                    commit('listProductCategory', { code: 'all', data: data.results, pagination: data.pagination });
                else
                    commit('listProductCategory', { code: 'more', data: data.results, pagination: data.pagination });
            }
            

            commit(PROGRESS_FINISH, null, { root: true });
        }).catch((err) => {
            commit('listProductCategory', { code: 'all', data: 'error', pagination: 0 });
            const { data } = err.response;
            dispatch('errorHandler', data);
            commit(PROGRESS_FAIL, null, { root: true });
        });
    },
    getAllCategory({ commit, dispatch }) {

        commit(PROGRESS_START, null, { root: true });

        listProductAPI.allProductCategory().then(({ data: { data } }) => {
            commit('listCategory', data);
            commit(PROGRESS_FINISH, null, { root: true });
        }).catch((err) => {
            const { data } = err.response;
            dispatch('errorHandler', data);
            commit(PROGRESS_FAIL, null, { root: true });
        });
    },
    errorHandler({ commit }, response) {
        commit('failed', { code: 'error_response', type: 'error', message: response.message });
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};